import { createSelector } from '@ngrx/store'

import * as facets from '../actions/facets'

import { PreppedGroups } from '../../facets/models/prepped-groups'
import { Facet } from '../../facets/models/facet'
import { FacetCount } from '../../facets/models/facet-count';
import { AppliedFacets } from '../../facets/models/applied-facets'

import { applyOver, createUXFacetGroups, prepFacetGroups, prepFacets } from '../../facets/helpers/facets'
import { hasProps } from '../../core/helpers/object'

export interface State {
    initGroups: boolean
    initFacets: boolean

    loading: boolean

    groups: PreppedGroups
    currentGroups: string[]

    facets: { [group: string]: Facet[] }
    facetCounts: { [group: string]: FacetCount[] }

    applied: AppliedFacets
}

const initialState: State = {
    initGroups: false,
    initFacets: false,
    loading: false,
    groups: {},
    currentGroups: [],
    facets: {},
    facetCounts: {},
    applied: {}
}

export function reducer(
    state = initialState,
    action: facets.Actions
) {
    switch(action.type){
        case facets.INIT_GROUPS:
            return {
                ...state,
                initGroups: true
            }
        case facets.INIT_GROUPS_SUCCESS:
            let preppedGroups = prepFacetGroups(action.payload)

            return {
                ...state,
                groups: preppedGroups,
                initGroups: false
            }
        case facets.INIT_GROUPS_FAILED:
            return {
                ...state,
                initGroups: false
            }

        case facets.INIT_FACETS:
            return {
                ...state,
                initFacets: true
            }
        case facets.INIT_FACETS_SUCCESS:
            let preppedFacets = prepFacets(action.payload)

            return {
                ...state,
                facets: preppedFacets,
                initFacets: false
            }

        case facets.INIT_FACETS_FAILED:
            return {
                ...state,
                initFacets: false
            }

        case facets.LOAD:
            return {
                ...state,
                loading: true
            }

        case facets.LOAD_SUCCESS:
            let facetCount = applyOver(action.payload)

            return {
                ...state,
                loading: false,
                facetCounts: facetCount,
                currentGroups: Object.keys(facetCount)
            }

        case facets.LOAD_FAILED:
            return {
                ...state,
                loading: false
            }

        case facets.APPLY:
            return {
                ...state,
                applied: action.payload
            }

        default:
            return state
    }
}

// Public Selectors
export const isInitializing =
    (state: State) => state.initGroups || state.initFacets
export const isLoading = (state: State) => state.loading

export const getFacets = (state: State) => state.facets
export const getGroups = (state: State) => state.groups
export const getCounts = (state: State) => state.facetCounts

export const getCurrentGroups = (state: State) => state.currentGroups
export const getAppliedFacets = (state: State) => state.applied

// Complex public selectors
export const hasApplied = createSelector(
    getAppliedFacets,
    applied => applied && hasProps(applied)
)
export const hasGroups = createSelector(
    getGroups,
    groups => groups && hasProps(groups)
)
export const hasFacets = createSelector(
    getFacets,
    facets => facets && hasProps(facets)
)

export const getFacetsUX = createSelector(
    getCurrentGroups,
    getGroups,
    getFacets,
    getCounts,
    createUXFacetGroups
)
